import { Component } from 'react';
import { observer } from 'mobx-react';
import { SalaryPeriodStatus } from '@Models';
import { ModalButtonType, ModalDialogOptions, ModalWindow, NotificationHandler } from '@Components';
import { MonthPicker } from '@Components/MonthPicker/MonthPicker';
import { ReopenDialogStore } from './ReopenDialogStore';
import { modalService } from '@Components/Modal/ModalService';

type ReopenDialogProps = {};


@observer
export default class ReopenDialog extends Component<ReopenDialogProps, {}> {
    private _store: ReopenDialogStore = new ReopenDialogStore();

    render() {
        const {setPeriod} = this._store;
        return <MonthPicker nextPeriodBtn={false} pervPeriodBtn={false} onChange={setPeriod} periodStatus={SalaryPeriodStatus.Released}/>;
    }

    public getModalOptions(window: ModalWindow<void>): ModalDialogOptions<void> {
        return {
            title: 'Confirmation',
            buttons: [{
                type: ModalButtonType.Cancel,
                onClick: () => {
                    window.close();
                }
            }, {
                color: 'success',
                title: 'Reopen',
                type: ModalButtonType.Confirm,
                onClick: async () => {
                    if (await modalService.showConfirmation('Do you really want to change period status back to Ready To Release?')){
                        await this._store.reopenSelectedPeriod();
                        NotificationHandler.showSuccess('Period changed status to back "Ready To Release" successfully');
                        window.close(ModalButtonType.Confirm);
                    }
                }
            }]
        };
    }
}
